import styled from 'styled-components';

import { TypeAllowed } from '.';

export const ModalContainer = styled.div`
	background-color: rgba(0 0 0 / 50%);
	height: 100%;
	left: 0;
	overflow: hidden;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 100;
`;

export type PositionTypeProps =
	| 'top-left'
	| 'top-right'
	| 'bottom-left'
	| 'bottom-right'
	| 'center';

interface ModalProps {
	readonly show: boolean;
	readonly type: TypeAllowed;
	readonly positionType?: PositionTypeProps;
}

const calculatePosition = (positionType: PositionTypeProps) => {
	switch (positionType) {
		case 'top-left':
			return { top: '20px', left: '20px' };
		case 'top-right':
			return { top: '20px', right: '20px' };
		case 'bottom-left':
			return { bottom: '20px', left: '20px' };
		case 'bottom-right':
			return { bottom: '20px', right: '20px' };
		case 'center':
			return { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
		default:
			return { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
	}
};
export const ModalContent = styled.div<ModalProps>`
	background-color: ${({ theme }) => theme.colors.principal.air};
	border-radius: 12px;
	box-shadow: 2px 0 34px rgba(88 87 87 / 14%);
	display: ${({ show }) => (show ? 'block' : 'none')};
	max-height: 99vh;
	max-width: 95vw;
	opacity: ${({ show }) => (show ? 1 : 0)};
	overflow-y: hidden;
	padding: 24px 12px;
	position: absolute;
	${({ positionType }) => calculatePosition(positionType || 'center')}
	width: ${({ type }) =>
		type === 'small'
			? 370
			: type === 'medium'
			? 520
			: type === 'large'
			? 720
			: type === 'xl-large'
			? 940
			: 370}px;

	z-index: 110;

	@media (max-width: 768px) {
		width: 90%;
	}
`;

export const ModalHeader = styled.header`
	align-items: center;
	border-top-left-radius: 12px;
	border-top-right-radius: 12px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 16px;
`;

export const ModalTextContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ModalTitle = styled.h1`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 18px;
	font-weight: 500;
	line-height: 28px;
`;

export const ModalSubTitleContainer = styled.div`
	align-items: center;
	display: flex;
`;

export const ModalSubTitle = styled.p`
	font-family: ${({ theme }) => theme.fonts.stack};
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
`;

export const ContainerIcon = styled.div`
	align-items: flex-start;
	display: flex;
`;
export const TimesContainer = styled.div`
	background-color: ${({ theme }) => theme.colors.principal.ceres};
	border-radius: 50%;
	cursor: pointer;
	display: grid;
	height: 40px;
	place-content: center;
	width: 40px;
`;

export const ModalBody = styled.div`
	border-bottom: 1px solid transparent;
	display: flex;
	height: 100%;
	justify-content: center;
	position: relative;
	width: 100%;
`;

export const ModalBodyWrapper = styled.div`
	max-height: 80vh;
	overflow-y: auto;

	&:nth-of-type(1) {
		background-color: transparent;
		border-bottom-left-radius: 12px;
		width: 100%;
	}

	&:nth-of-type(2) {
		background-color: ${({ theme }) => theme.colors.principal.air};
		border-bottom-right-radius: 12px;
		min-width: 315px;
	}
`;
